import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import deviceColumns from "./deviceColumns";

type Props = {
  name: string;
};

const query = gql`
  query AllDevices($offset: Int, $limit: Int) {
    devices(offset: $offset, limit: $limit) {
      created_at
      app_version
      build_type
      build_version
      device_only_fraud_status
      first_name
      model
      name
      phone_number
      platform
      platform_version
      rooted
      snapmin_url
      status
      surname
      user_agent
      external_reference
      token
      user {
        email
        external_reference
        snapmin_url
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      offset,
      limit
    }
  })
});

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={deviceColumns}
        defaultColumns={[
          "Date",
          "First name",
          "Surname",
          "Phone number",
          "User"
        ]}
        rows={props.data.devices || []}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
